import {Fragment, h} from 'preact';
import s from "./sidebarCart.module.css";
import {iconClose} from "../../assets";
import Content from "./Content";
import {useSidebarCart} from "./useSidebarCart";
import {ScopedLoader} from "../index";
import {useAppContext, useBehavioralContext} from '../../contexts';

const SidebarCart = () => {
    // Retrieves all the cart related stuff
    const {
        sidebarCartData,
        handleCart
    } = useBehavioralContext();

    // Component logic data
    const componentProps = useSidebarCart({
        sidebarCartData,
    });

    // Destructured component logic data
    const {
        isLoading,
        handleCartLoader,
        manuallyRemoveOverflow
    } = componentProps;

    // Accessibility feature data
    const {highContrast} = useAppContext();

    // Initial header section containing the leading title and the close icon
    const header = (
        <div className={s.header}>
            <p 
                className={`${s.leadingTitle}`}
            >
                Carrinho
            </p>
            <button
                type={"button"}
                className={s.closeButton}
                onClick={() => handleCart("isOpen", false)}
                data-testid="sidebar-button"
            >
                <p className={`${highContrast ? "!text-white" : ""}`}>
                    Fechar
                </p>
                <img
                    src={iconClose}
                    alt={"Close icon"}
                    className={`${highContrast ? s.iconFilter : ""}`}
                />
            </button>
        </div>
    )

    // Loader variable
    const loader = isLoading && <ScopedLoader />;

    return (
        <Fragment>
            <div
                className={`${s.root} ${(sidebarCartData.isOpen ? s.isOpen : "")} ${highContrast ? "highGrayColor" : ""}`}
                data-testid="sidebar-cart-container"
            >
                <div className={"w-full h-full flex flex-col items-start relative z-0"}>
                    {/* Header section */}
                    {header}

                    {/* Cart content section. All data that will be listed on it should be passed to it as a property */}
                    <Content
                        handleCartLoader={handleCartLoader}
                        manuallyRemoveOverflow={manuallyRemoveOverflow}
                    />

                    {loader}
                </div>
            </div>

            {/* Backdrop element */}
            <div
                className={s.backdrop + (sidebarCartData.isOpen ? ` ${s.openBackdrop}` : "")}
                onClick={() => handleCart("isOpen", false)}
                data-testid="sidebar-cart-backdrop"
            />
        </Fragment>
    )
}

export default SidebarCart;
